import React from 'react';
import { SignUpSuccessContainer } from '../../../../containers';

export const SignUpSuccess = () => <SignUpSuccessContainer />;
